// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const FaceMouthClosedOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M64.707 50.991a2 2 0 0 0-4 0c0 6.863-5.7 12.447-12.707 12.447-7.007 0-12.708-5.584-12.708-12.447a2 2 0 0 0-4 0c0 9.069 7.495 16.447 16.708 16.447 9.212 0 16.707-7.378 16.707-16.447Zm-6.451-20.43c-1.691 0-3.062 2.095-3.062 4.679s1.371 4.678 3.062 4.678c1.69 0 3.061-2.094 3.061-4.678s-1.371-4.679-3.061-4.679Zm-20.549 0c-1.691 0-3.062 2.095-3.062 4.679s1.371 4.678 3.062 4.678c1.691 0 3.062-2.094 3.062-4.678s-1.371-4.679-3.062-4.679ZM48 12.5c-19.575 0-35.5 15.925-35.5 35.5 0 19.574 15.925 35.499 35.5 35.499S83.5 67.574 83.5 48c0-19.575-15.925-35.5-35.5-35.5Zm0 74.999C26.22 87.499 8.5 69.78 8.5 48S26.22 8.5 48 8.5 87.5 26.22 87.5 48 69.78 87.499 48 87.499Z"
			fill="#fff"
		/>
	</svg>
);
export default FaceMouthClosedOutline;
